<template>
  <div>
    Extend me!
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: 'unknown',
    }
  },

  computed: {

    active () {
      return this.currentView.page == this.id
    },

    activeSubpage () {
      return this.currentView.subpage
    },

    currentView () {
      return this.$store.getters['account/current']
    },

    oldSubpage () {
      return this.oldView.subpage
    },

    oldView () {
      return this.$store.getters['account/from']
    },

    user () {
      return this.$store.getters['user/account']
    },

    wasActive () {
      return this.oldView.page == this.id
    },

  },

  methods: {

    changePage (which) {
      this.$store.commit('account/navigateSubpage', which.id)
    },

    isActivatedSubpage (which) {
      return this.activeSubpage == which || this.oldSubpage == which
    },

  }
}
</script>
